<div
  class="card card-well top-buffer animate__animated animate__fadeIn animate__faster"
  data-automation="send-email-container"
>
  <div class="card-header">
    <legend class="bottom-buffer mt-0 pb-2">
      <ziro-stacked-icon
        [stackedIcon]="ZiroStackedIcons[ziroIcons.SEND_EMAIL_CIRCLED]"
        parentClass="fa-stack"
      ></ziro-stacked-icon>

      <span>{{ 'tkey;helpdesk.send_email.table.title' | translate }}</span>
    </legend>
    <p>{{ 'tkey;helpdesk.send_email.table.helptext' | translate }}</p>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading) {
      <div class="send-email__table-card">
        <ziro-datatable
          [class]="'ziro-card'"
          [columns]="columns"
          [rowDataSource]="tableRows"
          [dataAutomation]="'send-email-datatable'"
          [uniqueRowIdentifier]="'emailTemplateName'"
        ></ziro-datatable>
      </div>
    }

    <div class="text-end pb-2 border-top pt-3">
      <ziro-button
        [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
        [buttonSize]="ButtonSizes.NORMAL"
        [label]="'tkey;global.button.cancel.text'"
        [dataAutomation]="'send-email-cancel-button'"
        (clicked)="goHome()"
      ></ziro-button>
    </div>
  </div>
</div>
